import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Chip, CircularProgress, Link, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getMe, errorMessage } from '../pages/Setup/wizardApi';
import { STEP_META } from '../pages/Setup/steps';

/**
 * Owner Console → Company → Company setup: where setup stands and a way back
 * into any step of the wizard (branding, about, services, agreements, …).
 */
export default function CompanySetup() {
  const navigate = useNavigate();
  const [org, setOrg] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    getMe().then(setOrg).catch((err) => setError(errorMessage(err, 'Could not load your company')));
  }, []);
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!org) return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
  const done = new Set(org.setup?.completedSteps || []);
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 2, flexWrap: 'wrap', gap: 1 }}>
        <Box>
          <Typography variant="h5">Company profile and setup</Typography>
          <Typography variant="body2" color="text.secondary">Your name, logo, colors, About text, agreements, provider requirements, social links and app links.</Typography>
        </Box>
        <Button variant="contained" onClick={() => navigate('/setup/wizard')}>Open setup</Button>
      </Box>
      <Alert severity={org.setup?.completedAt ? 'success' : 'info'} sx={{ mb: 2 }}>
        {org.setup?.completedAt ? `Setup completed on ${new Date(org.setup.completedAt).toLocaleDateString()}. Status: ${org.status}.` : 'Setup is not finished yet. Required steps are marked.'}
      </Alert>
      <Paper variant="outlined">
        <List dense disablePadding>
          {STEP_META.filter((s) => s.key !== 'finish').map((s) => (
            <ListItem key={s.key} divider secondaryAction={<Button size="small" onClick={() => navigate(`/setup/wizard?step=${s.key}`)}>Open</Button>}>
              <ListItemText primary={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{s.label}{s.required && <Chip size="small" label="Required" variant="outlined" />}</Box>}
                secondary={done.has(s.key) ? 'Done' : 'Not done yet'} />
            </ListItem>
          ))}
        </List>
      </Paper>
      <Typography variant="body2" sx={{ mt: 2 }}>
        Public addresses: <Link href={org.urls?.portal} target="_blank" rel="noopener">{org.urls?.portal}</Link> · <Link href={org.urls?.customerSite} target="_blank" rel="noopener">{org.urls?.customerSite}</Link> · <Link href={org.urls?.applicationForm} target="_blank" rel="noopener">{org.urls?.applicationForm}</Link>
      </Typography>
    </Box>
  );
}
